<template>
  <div class="common-public">
    <b-navbar toggleable="sm" type="dark" :variant="color" fixed="top">
      <b-navbar-toggle target="nav_collapse"></b-navbar-toggle>
      <b-collapse is-nav id="nav_collapse">
        <b-navbar-nav class="ml-auto">
          <b-nav-item to="/policy">利用規約</b-nav-item>
          <b-nav-item to="/auth/login">ログイン</b-nav-item>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'CommonPublic',

  data() {
    let color = 'dark';
    if (process.env.VUE_APP_ENV == 'development') {
      color = 'danger';
    } else if (process.env.VUE_APP_ENV == 'staging') {
      color = 'primary';
    }
    return {
      color: color,
    };
  },
};
</script>

<style scoped>
</style>
